/** @format */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFetch } from "../../../../hooks/useFetch";
import OverviewInput from "../../../../CommonComponents/InitialInput/OverviewInput";
import { LoadingScreen } from "../../../../CommonComponents/LoadingScreen/index";
import ListModal from "../../../../CommonComponents/Modal/DropDownModal/DropDownListMUI";
import CircleButton from "../../../../CommonComponents/CircleButton";
import MessageLog from "../../../../CommonComponents/Messages/MessageLog";
import { GetFullURL } from "../../../../CommonComponents/GlobalConfFiles/URLs";
import OverviewButtons from "./Components/OverviewButtons";
import cardlogo from "../../../../Assets/cardLogo.svg";
import { useMessage } from "../../../../hooks/UseMessage";

export default function AdminFunctionOverview(props) {

  let navigate = useNavigate();
  const [vehicleParam, setVehicleParam] = useState();
  const [showVehiclesList, setShowVehiclesList] = useState(false);
  const [_createErrorMessage, _errorMessages, _setErorMessages] = useMessage();
  
  const [
    _deleteVehicle,
    ,
    _setDeleteVehicleData,
    _errorDeleteVehicleData,
    _setErrorDeleteVehicleData,
    _successDeleteVehicleData,
    _setSuccessDeleteVehicleData,
    _loadingDeleteVehicleData,
  ] = useFetch(GetFullURL("DeleteVehicle"), { method: "POST" });

  const [_getVehiclesList, _vehiclesList, , , , , , _loadingVehiclesList] =
    useFetch(GetFullURL("GetAllVehiclesForDelete"), { method: "POST" });

  const [_vehicleExist, , , , , , , _loadingVehicleExist] = useFetch(GetFullURL("VehicleExist"),{ method: "POST" });

  function clearMessages(e) {
    e.stopPropagation();
    let type = e.target.dataset.type;
    switch (type) {
      case "success":
        _setSuccessDeleteVehicleData([]);
        break;
      case "error":
        _setErorMessages([]);
        _setErrorDeleteVehicleData([]);
        break;
      case "warning":
      default:
        break;
    }
  }
  const operationLoading =  _loadingVehiclesList  || _loadingVehicleExist ;

  return (
    <section className="heroCard heroPartner">
      {operationLoading && <LoadingScreen />}
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="cardHeader">
                <h2>
                  <span>
                  <img src={require("../../../../Assets/icon/Admin.png")} className="img-fluid cardLogo" alt="" />
                  </span>
                  Vehicle Admin Overview
                </h2>
              </div>
              <div className="cardBody">
                <div className="cardInput">
                  <OverviewInput
                    setDocument={setVehicleParam}
                    document={vehicleParam}
                    vehicleRadius={true}
                    placeholder={`Enter or Choose Id`}
                  />
                </div>
                <div className="cardButton">
                  <CircleButton
                    buttonText={`List of Vehicles`}
                    clickHandler={() => {
                      _getVehiclesList({},() => {setShowVehiclesList(true);});                  
                    }}
                  />
                  <OverviewButtons
                    vehicle={vehicleParam}
                    navigate={navigate}
                    _vehicleExist={_vehicleExist}
                    _createErrorMessage={_createErrorMessage}
                    _deleteVehicle={_deleteVehicle}
              
                  />
                </div>
              </div>
            </div>
            <MessageLog
              errorMessages={[..._errorMessages, ..._errorDeleteVehicleData ]}
              successMessages={[..._successDeleteVehicleData]}
              warningMessages={[]}
              clearMessages={clearMessages}
            ></MessageLog>
             <div className="cardAlert">
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <ListModal
              setId={setVehicleParam}
              dataList={_vehiclesList}
              showListModal={showVehiclesList}
              setShowModal={setShowVehiclesList}
              title="List Of Vehicles"
              columns={[
                { field: "id", headerName: "Vehicle ID", width: 100 },
                { field: "vehicleTypeId", headerName: "Vehicle Type", width: 250 },
                { field: "vehicleName", headerName: "Name", width: 350 },
                ]}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

